export const NoResultMsg = () => {
	return <p className='fw-normal m-0'>No data available</p>;
};
